import React from 'react'
import { useDispatch } from 'react-redux'

import { uploadVoipCampaignCSV } from '@/reducers/organizations/organizationVoipCampaigns.actions'
import {
  setParsedCsv,
  updateUploadResponse,
} from '@/reducers/organizations/organizationVoipCampaignsCSV.redux'
import exampleVoipCSV from '@/assets/images/exampleVoipCSV.png'

import { CsvInstructions } from '../CsvInstructions/CsvInstructions'
import { downloadCsvTemplate } from '../CsvInstructions/helpers'
import { headersWhiteList, parseCSVData } from './helpers'

const TEMPLATE_DATA = [
  headersWhiteList,
  ['fake campaign', 'my playbook', ''],
  ['campaign to delete', '', 'true'],
]

const TEMPLATE_FILENAME = 'balto_bulk_voip_campaign_upload_template.csv'

const REQUIRED_HEADERS = ['campaign_name']
const OPTIONAL_HEADERS = ['playbook_name', 'delete']

const titlesAndDescriptions = {
  campaign_names: () => 'Campaign names are case insensitive',
  playbooks: () =>
    'Playbook names <strong>must match exactly</strong> (case sensitive, whitespace, etc.)',
  upsert_behavior: () =>
    'The upload performs an <strong>upsert operation</strong>: <strong>New campaigns</strong> will be created, <strong>existing campaigns with the same playbook</strong> will be left unchanged, and <strong>existing campaigns with different playbooks</strong> will be updated to use the new playbook automatically (no deletion required)',
  delete_flag: () =>
    'If set to <strong>TRUE</strong> or <strong>1</strong>, will delete the mapping for the campaign, regardless of the playbook value of the row',
}

const headersContent = (
  <>
    We <strong>only</strong> accept these headers
    <ul>
      {REQUIRED_HEADERS.map((required) => (
        <li key={required}>
          <code>{required}</code>
        </li>
      ))}
      {OPTIONAL_HEADERS.map((option) => (
        <li key={option}>
          <code>{option}</code>{' '}
          {option === 'playbook_name' ? '(optional only when deleting campaigns)' : '(optional)'}
        </li>
      ))}
    </ul>
  </>
)

export const Instructions = ({ nextPanel, organizationId }) => {
  const dispatch = useDispatch()

  const handleCSVUpload = async (csvData) => {
    const parsedData = parseCSVData(csvData)
    dispatch(setParsedCsv(parsedData))

    try {
      const dryRunResponse = await dispatch(uploadVoipCampaignCSV(organizationId, parsedData, true))
      dispatch(updateUploadResponse(dryRunResponse))
      nextPanel()
    } catch (error) {
      // fetchingAPI shows "Action Failed" alert on error
      console.error('Error uploading CSV:', error)
    }
  }

  return (
    <CsvInstructions
      templateImageSrc={exampleVoipCSV}
      templateImageAlt="Example VoIP campaign CSV"
      onDownloadTemplate={() => downloadCsvTemplate(TEMPLATE_DATA, TEMPLATE_FILENAME)}
      headersContent={headersContent}
      titlesAndDescriptions={titlesAndDescriptions}
      onCsvLoaded={handleCSVUpload}
    />
  )
}
